import React from 'react';
import { ChevronsLeft, ChevronsRight, ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
    page: number;
    pageSize: number;
    totalItems: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    pageSizeOptions?: number[];
    itemLabel?: string;
}

const PaginationFooter: React.FC<Props> = ({
    page,
    pageSize,
    totalItems,
    onPageChange,
    onPageSizeChange,
    pageSizeOptions = [6, 12, 24, 48],
    itemLabel = 'items',
}) => {
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-2">
            <span className="text-sm text-gray-600">
                Showing <strong>{totalItems === 0 ? 0 : (page - 1) * pageSize + 1}</strong> to{' '}
                <strong>{Math.min(page * pageSize, totalItems)}</strong> of{' '}
                <strong>{totalItems}</strong> {itemLabel}
            </span>

            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 text-sm">
                    Rows per page
                    <select
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        className="border rounded px-2 py-1"
                    >
                        {pageSizeOptions.map((s) => (
                            <option key={s} value={s}>{s}</option>
                        ))}
                    </select>
                </div>

                <div className="flex items-center gap-1">
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(1)}
                        className="p-1 border rounded disabled:opacity-50"
                    >
                        <ChevronsLeft size={16} />
                    </button>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        className="p-1 border rounded disabled:opacity-50"
                    >
                        <ChevronLeft size={16} />
                    </button>
                    <span className="px-2 text-sm">
                        Page <strong>{page}</strong> / {totalPages}
                    </span>
                    <button
                        disabled={page >= totalPages}
                        onClick={() => onPageChange(page + 1)}
                        className="p-1 border rounded disabled:opacity-50"
                    >
                        <ChevronRight size={16} />
                    </button>
                    <button
                        disabled={page >= totalPages}
                        onClick={() => onPageChange(totalPages)}
                        className="p-1 border rounded disabled:opacity-50"
                    >
                        <ChevronsRight size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaginationFooter;
